export default __webpack_public_path__ + "static/media/bgImg.521d6d96.jpeg";